import script from "./ServiceContractSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceContractSelection.vue?vue&type=script&setup=true&lang=js"

import "./ServiceContractSelection.vue?vue&type=style&index=0&id=384c6fbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384c6fbe"]])

export default __exports__